
import { apiClient } from "./api";

import axios from "axios";
import { xEnv } from "@/utils/helpers";

let walletsBaseUrl = process.env.VUE_APP_WALLETS_BASE_URL;

export default {
	createWallet(body) {
		return apiClient.post(`Authorize/CreateWalletApi`, body);
	},
	getBankProvidersFromCore() {
		return apiClient.get(`Authorize/GetWalletBanks`);
	},
	getWalletInfo(userDetails) {
		let headers = {
			clientid: userDetails.clientID,
		};
		return apiClient.get(`wallets/info/NGN`, headers);
	},
	getCustomers(apiKey, pagination) {
		let { page, limit, query } = pagination;
		query = JSON.stringify(query);
		return axios.get(
			`${walletsBaseUrl}/customers?page=${page}&limit=${limit}&query=${query}`,
			{
				headers: {
					"x-api-key": apiKey,
				},
			}
		);
	},
	getTransactions(apiKey, customer, pagination) {
		let { page, limit, query } = pagination;
		query = JSON.stringify(query);

		let url = `${walletsBaseUrl}/transactions?page=${page}&limit=${limit}&query=${query}`;

		if (customer) {
			url += `&customer=${customer}`;
		}
		return axios.get(url, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
	createPaymentCollection(apiKey, body) {
		return axios.post(
			`${walletsBaseUrl}/wallets/master/collections`,
			body,
			{
				headers: {
					"x-api-key": apiKey,
				},
			}
		);
	},
	createPaymentLink(apiKey, body) {
		return axios.post(`${walletsBaseUrl}/paymentlink`, body, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
	getPaymentLinks(apiKey) {
		return axios.get(`${walletsBaseUrl}/paymentlink`, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
	createCustomer(apiKey, body) {
		return axios.post(`${walletsBaseUrl}/customers`, body, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
	getWallets(apiKey, pagination) {
		let { page, limit, query } = pagination;
		query = JSON.stringify(query);
		return axios.get(`${walletsBaseUrl}/wallets`, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
	createSubMerchant(merchantDetails) {
		return axios.post(
			`${walletsBaseUrl}/wallets`,
			merchantDetails.payload,
			{
				headers: {
					"x-api-key": merchantDetails.apiKey,
				},
			}
		);
	},
	getMasterWallet(apiKey) {
		return axios.get(`${walletsBaseUrl}/wallets/master`, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
	getWalletHistory() {
		return apiClient.get(`/Authorize/wallet/transaction`);
	},
	getAPIKeys() {
		return apiClient.get(`/Authorize/Settings/GetKeys`);
	},
	changeKey(key) {
		return apiClient.put(`/Authorize/Settings/ChangeKeys?${key}=true`, {});
	},
	getCurrencies() {
		return axios.get(`${walletsBaseUrl}/currency`);
	},
	resolveBankName(userDetails) {
		try {
			let headers = {
				"x-api-key": userDetails.apiKey,
			};
			return axios.get(
				`${walletsBaseUrl}/resolve-bank/${userDetails.account_number}?bank_code=${userDetails.bank_code}`,
				{ headers }
			);
		} catch (error) {}
	},
	// withdrawFunds(withdrawDetails) {
	// 	try {
	// 		let headers = {
	// 			"x-api-key": withdrawDetails.apiKey,
	// 		};
	// 		return axios.put(
	// 			`${walletsBaseUrl}/wallets/${withdrawDetails.walletID}`,
	// 			withdrawDetails.payload,
	// 			{ headers }
	// 		);
	// 	} catch (error) {}
	// },
	withdrawFunds({ apiKey, payload }) {
		return axios.get(`${walletsBaseUrl}//merchant/withdrawal`, payload, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},

	initializeSDK(walletDetails) {
		try {
			let headers = {
				Authorization: walletDetails.apiKey,
				"x-api-key": xEnv,
			};
			return axios.post(
				`${walletsBaseUrl}/checkout/initialize`,
				walletDetails.payload,
				{ headers }
			);
		} catch (error) {}
	},
	updateWebHook(webHookData) {
		let headers = {
			"x-api-key": webHookData.apiKey,
		};
		return apiClient.put(
			`/Authorize/Settings/SetWebhook?environment=${webHookData.environment}`,
			{ webhook: webHookData.webhook },
			{ headers }
		);
	},
	addBank(bankData) {
		return axios.post(
			`${walletsBaseUrl}/merchant/bank/add`,
			bankData.payload,
			{
				headers: {
					"x-api-key": bankData.apiKey,
				},
			}
		);
	},
	updateMerchantSettings(merchantData) {
		return axios.put(
			`${walletsBaseUrl}/merchant/setting`,
			merchantData.payload,
			{
				headers: {
					"x-api-key": merchantData.apiKey,
				},
			}
		);
	},
	updateMerchantAccount({ apiKey, request }) {
		return axios.put(`${walletsBaseUrl}/merchant/account`, request, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
	getMerchantWalletSettings(apiKey) {
		return axios.get(`${walletsBaseUrl}/merchant/setting/detail`, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
	merchantToggleSettings(settingsData) {
		return axios.put(
			`${walletsBaseUrl}/merchant/setting/toggle`,
			settingsData.payload,
			{
				headers: {
					"x-api-key": settingsData.apiKey,
				},
			}
		);
	},
	requestOtp(otpData) {
		return axios.post(
			`${walletsBaseUrl}/merchant/${otpData.url}`,
			otpData.payload,
			{
				headers: {
					"x-api-key": otpData.apiKey,
				},
			}
		);
	},
	getMerchantBanks(apiKey) {
		return axios.get(`${walletsBaseUrl}/merchant/bank/detail`, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
	getMerchantPayout(apiKey) {
		return axios.get(`${walletsBaseUrl}/merchant/payouts`, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
	getMerchantSubAccounts(apiKey) {
		return axios.get(`${walletsBaseUrl}/subaccounts`, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
	getBankProviders(apiKey) {
		return axios.get(`${walletsBaseUrl}/bank-providers`, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
	createMerchantSubAccounts(subAccountData) {
		return axios.post(
			`${walletsBaseUrl}/subaccounts`,
			subAccountData.payload,
			{
				headers: {
					"x-api-key": subAccountData.apiKey,
				},
			}
		);
	},

	// -- Untested
	getPaymentCollections(apiKey) {
		return axios.get(`${walletsBaseUrl}/wallets/collections`, {
			headers: {
				"x-api-key": apiKey,
			},
		});
	},
};
